import React, { useEffect, useState } from 'react';
import { dropDownServices } from '../utils/Data';
import { Link } from 'react-router-dom';
import './Demo.css'

function Demo() {
    const [arr, setarr] = useState([])
    useEffect(() => {
        const handleVisibilityChange = () => {
          if (document.hidden) {
            console.log("Tab is not active");
            setarr([...arr,arr.push("Tab is not active")])
          } else {
            console.log("Tab is active");
            setarr([...arr,arr.push("Tab is  active")])
          }
        };
    
        document.addEventListener("visibilitychange", handleVisibilityChange);
    
        // Cleanup function to remove the event listener when the component unmounts
        return () => {
          document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
      }, [arr]); // Empty dependency array ensures this runs only on mount and unmount
    

  return (
    <div className=" bg-gray-400">
     {arr.map((item)=>{
        return <h1>{item}</h1>
     })}
    </div>
  );
}

export default Demo;